import gsap from 'gsap'

export default class Image {
  constructor(el) {
    this.DOM = el
    this.defaultStyle = {
        scale: 1,
        x: 0,
        y: 0,
        opacity: 0
    }

    this.bindMethods()
    this.getRect()
    this.initEvents()
  }

  bindMethods() {
    this.resize = this.resize.bind(this)
  }

  initEvents() {
    window.addEventListener('resize', this.resize)
  }

  resize() {
    gsap.set(this.DOM, this.defaultStyle)
    this.getRect()
  }

  getRect() {
    this.rect = this.DOM.getBoundingClientRect()
  }

  isActive() {
    return gsap.isTweening(this.DOM) || this.DOM.style.opacity !== 0
  }
}



// WEBPACK FOOTER //
// ./scripts/util/Image.js